import React from 'react';
import PlaceholderPage from './PlaceholderPage';
import { CreditCard } from 'lucide-react';

export default function ReviewCardsNewPage() {
  return (
    <PlaceholderPage
      title="Review Cards"
      description="Manage NFC review cards for customers. Coming soon!"
      icon={CreditCard}
    />
  );
}
